import React from 'react';
import {authService} from './../../services/authService'

//ui Component

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Dialog from '@material-ui/core/Dialog';
import AtencyTextField from './../shared/AtencyTextField';

import Grid from '@material-ui/core/Grid';
import DialogTitle from '@material-ui/core/DialogTitle';

export default class CountryCodeList extends React.Component{
    constructor(props){
        super(props);
        this.state={
            countryCodes:[],
            countryCode:'+98',
            open:false

        }
       
    }
    componentDidMount = async ()=>{
        let req = {
            method:'GET',
            url:"/api/WorkplaceAPI/CountryList_Read",
            authorized : false
        }
        try{
            const result = await authService.request(req);
            this.setState({
                countryCodes : result
            })
        }catch(error){
            console.log(error)
        }
        
    }
     //modal
    hadndleOpenModal = ()=>{
        this.setState({open : true})
    }
    handleModalClose = () => {
        this.setState({open : false})
    };
    handleListItemClick = (country)=>{

        this.setState({
            countryCode:country.CallingCode
        })
        this.handleModalClose();
       
        this.props.setCountryCode(country)
    }
    CountryCodeInputChange = (event) => {
        event.preventDefault();
    }
    render = () => {
        
        return(
            <div>
                <Grid item xs={12} className="pr-1">
                    <AtencyTextField color="secondary" label="کد" onClick={this.hadndleOpenModal} value={this.state.countryCode} onChange={this.CountryCodeInputChange}></AtencyTextField>          
                </Grid>
           
            <Dialog  disableEscapeKeyDown open={this.state.open} onClose={this.handleModalClose}>
                <DialogTitle>Fill the form</DialogTitle>
                    <List>
                        {this.state.countryCodes.map(country => (
                        <ListItem button onClick={() => this.handleListItemClick(country)} key={country.ID}>
                            <ListItemAvatar>
                                <div
                                    alt={country.Code}
                                    className={`flag flag-${country.Code.toLowerCase()}`}
                                />
                            </ListItemAvatar>
                            <ListItemText primary={country.CallingCode} />
                        </ListItem>
                        ))}
                    </List>
            </Dialog>  
            </div>
                      
        )
    }
}